<template>
  <div v-if="hasMedia" class="product-media-gallery">
    <IntersectionObserver @on-intersection="trackView">
      <MediaGallery
        :media="media"
        :useBackgroundImages="true"
        :showCarouselPagination="showCarouselPagination"
        :showLightboxNavigationButtons="false"
        :captionVariant="CAPTION_VARIANTS.centered"
        :carouselSlidePaddingRightMobile="0"
        :carouselSlidePaddingRightDesktop="0"
        :carouselSpaceRightDesktop="0"
        :carouselSpaceRightMobile="0"
        @click.native="trackClick"
      />
    </IntersectionObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IntersectionObserver from '@/components/_shared/IntersectionObserver.vue'
import MediaGallery, { CAPTION_VARIANTS } from '@/components/_shared/MediaGallery/MediaGallery.vue'

export default {
  name: 'ProductMediaGallery',
  components: {
    IntersectionObserver,
    MediaGallery,
  },

  props: {
    media: {
      type: Array,
      required: true,
    },

    campaignIds: {
      type: Object,
    },
  },

  data() {
    return {
      CAPTION_VARIANTS,
    }
  },

  computed: {
    ...mapGetters({
      isMqLarge: 'viewport/isMqLarge',
    }),

    showCarouselPagination() {
      return !this.isMqLarge
    },

    hasMedia() {
      return this.media.length > 0
    },

    campaignIdentifier() {
      const firstMedia = this.media[0] || {}
      return `media-gallery__${firstMedia?.title || firstMedia?.url}`
    },
  },

  methods: {
    /**
     * Remove campaign view and click reporting once A/B test is over
     * @see https://onrunning.atlassian.net/browse/B2C-4489
     * @see https://github.com/onrunning/on/pull/5021/commits/dffa8d7f7fd45b465dfe0d78a919c5fbf5f5084b
     */
    trackView() {
      if (!this.campaignIds) return

      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.campaignView,
        data: { identifier: this.campaignIdentifier },
      })
    },

    trackClick() {
      if (!this.campaignIds) return

      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.campaignClick,
        campaignIds: this.campaignIds,
        data: { identifier: this.campaignIdentifier },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../pdp-settings';

.product-media-gallery {
  @extend %u-pdp-section-height;

  /deep/ .media-gallery {
    &__carousel-image {
      @extend %u-pdp-section-height;
    }
  }
}
</style>
